import { HelmetProvider } from "react-helmet-async";
import IntroDialog from "./components/intro_dialog";
import Header from "./components/header";
import { useState } from "react";
import translate from "./locales";
import STEPS from "./data/steps";
import hairImage from "./assets/images/hair.png";
import clsx from "clsx";
import { Analytics } from "./components/analytics";

export default function App() {
  const [activeStep, setActiveStep] = useState(STEPS[0]);
  return (
    <HelmetProvider>
      <Analytics />
      <Header />
      <IntroDialog></IntroDialog>
      <main className="page__main">
        <h2 className="page__headline">
          <span className="page__headline-count">
            {translate(["steps", activeStep.key, "device_count"])}
          </span>
          <span className="page__headline-device">
            {translate(["steps", activeStep.key, "device_text"])}
          </span>
        </h2>
        <SliderCard activeStep={activeStep} setActiveStep={setActiveStep} />
        <DeviceCard activeStep={activeStep} />
        <VolumeCard activeStep={activeStep} />
        <ThicknessCard activeStep={activeStep} />
      </main>
      <div className="page__background background">
        <img
          className={clsx("background__item", "background__item--desktop")}
          loading="lazy"
          decoding="async"
          src={activeStep.backgroundDesktop}
          alt=""
          key={`${activeStep.key}-desktop`}
          data-period={activeStep.key}
        />
        <img
          className={clsx("background__item", "background__item--mobile")}
          loading="lazy"
          decoding="async"
          src={activeStep.backgroundMobile}
          alt=""
          key={`${activeStep.key}-mobile`}
          data-period={activeStep.key}
        />
      </div>
      <Announcer activeStep={activeStep} />
    </HelmetProvider>
  );
}

function SliderCard({ activeStep, setActiveStep }) {
  const currentIndex = STEPS.findIndex((step) => step === activeStep);

  function handleInput(event) {
    setActiveStep(STEPS[event.target.value]);
  }

  return (
    <div className="card page__slider">
      <h2 className="card__title" id="sliderLabel">
        {translate("main.slider_instructions")}
      </h2>
      <div className="slider">
        <input
          type="range"
          name="slider"
          value={currentIndex}
          onInput={handleInput}
          min={0}
          max={STEPS.length - 1}
          step={1}
          list="steps"
          className="slider__field"
          aria-labelledby="sliderLabel"
        />
        <div id="steps" className="slider__list">
          {STEPS.map((step, index) => (
            <span
              key={step.key}
              value={index}
              className="slider__option"
              data-selected={currentIndex === index}
              onClick={() => setActiveStep(step)}
            >
              {translate(["steps", step.key, "label"])}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export function DeviceCard({ activeStep }) {
  return (
    <div className="card card--center page__device">
      <img
        src={activeStep.deviceImage}
        className="card__image"
        alt={translate(["steps", activeStep.key, "device_alt"])}
      />
      <p
        className="card__title"
        key={activeStep.key}
        dangerouslySetInnerHTML={{
          __html: translate(
            ["main", "devices", activeStep.yearSpecial ? "special" : "normal"],
            {
              year: translate(["steps", activeStep.key, "year"]),
              device: `${translate(["steps", activeStep.key, "device_count"])} ${translate(["steps", activeStep.key, "device_text"])}`,
            },
          ),
        }}
      ></p>
    </div>
  );
}

export function VolumeCard({ activeStep }) {
  return (
    <div className="card card--center page__volume">
      <img
        src={activeStep.volumeImage}
        className="card__image"
        alt={translate(["steps", activeStep.key, "volume_alt"])}
      />
      <p
        className="card__title"
        key={activeStep.key}
        dangerouslySetInnerHTML={{
          __html: translate(
            [
              "main",
              "transistors",
              activeStep.volumeSpecial ? "special" : "normal",
            ],
            {
              year: translate(["steps", activeStep.key, "year"]),
              volume: translate(["steps", activeStep.key, "volume_text"]),
            },
          ),
        }}
      ></p>
    </div>
  );
}

export function ThicknessCard({ activeStep }) {
  return (
    <div className="card card--center page__thickness">
      <img src={hairImage} alt="" className="card__image" />
      <p
        className="card__title"
        dangerouslySetInnerHTML={{
          __html: translate(
            [
              "main",
              "thickness",
              activeStep.thickness === 1 ? "equal" : "thinner",
            ],
            {
              count: activeStep.thickness,
            },
          ),
        }}
      ></p>
    </div>
  );
}

function Announcer({ activeStep }) {
  const texts = [
    translate(
      ["main", "devices", activeStep.yearSpecial ? "special" : "normal"],
      {
        year: translate(["steps", activeStep.key, "year"]),
        device: `${translate(["steps", activeStep.key, "device_count"])} ${translate(["steps", activeStep.key, "device_text"])}`,
      },
    ),
    translate(
      ["main", "transistors", activeStep.volumeSpecial ? "special" : "normal"],
      {
        year: translate(["steps", activeStep.key, "year"]),
        volume: translate(["steps", activeStep.key, "volume_text"]),
      },
    ),
    translate(
      ["main", "thickness", activeStep.thickness === 1 ? "equal" : "thinner"],
      {
        count: activeStep.thickness,
      },
    ),
  ];
  const regex = /(<([^>]+)>)/gi;
  const result = texts.map((t) => t.replace(regex, ""));

  return (
    <div
      className="sr-only"
      tabIndex={-1}
      aria-live="polite"
      aria-atomic="true"
    >
      {result}
    </div>
  );
}
